export default "__VITE_PUBLIC_ASSET__89281b58__"